import { types, flow } from "mobx-state-tree";
import fetcher from "../utils/fetcher";
import { getErrorMessage } from "../utils/helper";

const SupportCallsStore = types
  .model("SupportCallsStore", {
    error: types.frozen(),
    supportCalls: types.frozen(),
    selectedSupportCall: types.frozen(),
    userCustomers: types.frozen(),
    supportCallTypes: types.frozen(),
    supportCallSeverityTypes: types.frozen(),
    supportCallStatuses: types.frozen(),
  })
  .actions((self) => {
    const getSupportCallsActive = flow(function* getSupportCallsActive(data) {
      self.setError("");
      self.setSupportCalls([]);
      self.setSelectedSupportCall("");
      const calls = yield fetcher()
        .post(data)
        .from.support_calls.get_support_calls_by_cust_active();
      if (calls.status === 200 && calls.data) {
        self.setSupportCalls(calls.data || []);
        if (Object.keys(self.supportCalls).length) {
          self.setSelectedSupportCall(self.supportCalls[0]);
        }
      } else {
        console.log("error_failed_get_support_calls_req");
        self.setError("error:error_failed_get_support_calls_req");
      }
    });

    const getSupportCallsHistory = flow(function* getSupportCallsHistory(data) {
      self.setError("");
      self.setSupportCalls([]);
      self.setSelectedSupportCall("");
      const calls = yield fetcher()
        .post(data)
        .from.support_calls.get_support_calls_by_cust_history();

      if (calls.status === 200 && calls.data) {
        self.setSupportCalls(calls.data || []);

        if (Object.keys(self.supportCalls).length) {
          self.setSelectedSupportCall(self.supportCalls[0]);
        }
      } else {
        const errorText = "error:error_failed_get_support_calls_req";

        self.setError(getErrorMessage(calls, errorText));
      }
    });

    const getSupportCall = flow(function* getSupportCall(data) {
      self.setError("");

      const call = yield fetcher()
        .post(data)
        .from.support_calls.get_support_call();
      if (call.status === 200 && call.data) {
        self.setSelectedSupportCall(call.data);
        return call.data;
      } else {
        console.log("error_failed_get_support_call_req");
        const errorText = "error:error_failed_get_support_call_req";

        self.setError(getErrorMessage(call, errorText));
      }
    });

    const getSupportCallStatuses = flow(function* getSupportCallStatuses(data) {
      self.setError("");

      const call = yield fetcher()
        .post(data)
        .from.support_calls.get_support_call_statuses();
      if (call.status === 200 && call.data) {
        self.setSupportCallStatuses(call.data.value);
        return call.data.value;
      } else {
        console.log("error_failed_get_support_call_statuses_req");
        const errorText = "error:error_failed_get_support_call_statuses_req";

        self.setError(getErrorMessage(call, errorText));
      }
    });

    const addNewComment = flow(function* addNewComment(data) {
      self.setError("");
      const call = yield fetcher()
        .post(data)
        .from.support_calls.add_new_comment();
      if (call.status === 200 && call.data) {
        const newComment = call.data;
        return newComment;
      } else {
        const errorText = "error:error_failed_add_new_comment_req";

        self.setError(getErrorMessage(call, errorText));
      }
    });

    const updateCommentExt = flow(function* updateComment(data) {
      self.setError("");
      const call = yield fetcher()
        .post(data)
        .from.support_calls.update_comment_ext();
      if (call.status === 200 && call.data) {
      } else {
        const errorText = "error:error_failed_update_comment_req";

        self.setError(getErrorMessage(call, errorText));
      }
    });

    const addNewSupportCall = flow(function* addNewSupportCall(data) {
      self.setError("");
      const call = yield fetcher()
        .post(data)
        .from.support_calls.new_support_call();
      if (call.status === 200 && call.data) {
        return call.data;
      } else {
        const errorText = "error:error_failed_add_new_support_call_req";

        self.setError(getErrorMessage(call, errorText));
      }
    });

    const updateSupportCall = flow(function* updateSupportCall(data) {
      self.setError("");
      const call = yield fetcher()
        .post(data)
        .from.support_calls.update_support_call();
      if (call.status === 200 && call.data) {
        return call.data;
      } else {
        const errorText = "error:error_failed_update_support_calll_req";

        self.setError(getErrorMessage(call, errorText));
      }
    });

    const addAttachment = flow(function* addAttachment(data) {
      self.setError("");
      const attachment = yield fetcher()
        .post(data)
        .from.support_calls.add_attachment();

      if (attachment.status === 200 && attachment.data) {
        return attachment.data;
      } else {
        const errorText = "error:error_failed_add_new_attachment_req";
        self.setError(getErrorMessage(attachment, errorText));
      }
    });

    const deleteAttachment = flow(function* deleteAttachment(data) {
      self.setError("");
      const call = yield fetcher()
        .post(data)
        .from.support_calls.delete_attahment();
      if (call.status === 200 && call.data) {
      } else {
        const errorText = "error:error_failed_delete_comment_req";
        self.setError(getErrorMessage(call, errorText));
      }
    });

    const getUserCustomers = flow(function* userCustomers(data) {
      self.setError("");
      const call = yield fetcher()
        .post(data)
        .from.support_calls.get_user_customers(data);
      if (call.status === 200 && call.data) {
        self.setUserCustomers(call.data || []);
      } else {
        const errorText = "error:error_failed_get_user_customers";
        self.setError(getErrorMessage(call, errorText));
      }
    });

    const getSupportCallTypes = flow(function* getSupportCallTypes() {
      self.setError("");
      const types = yield fetcher().post().from.support_calls.get_types();
      if (types.status === 200 && types.data) {
        self.setSupportCallTypes(types.data.value || []);
      } else {
        const errorText = "error:error_get_support_call_types_req";
        self.setError(getErrorMessage(types, errorText));
      }
    });

    const getSupportCallSeverityTypes = flow(
      function* getSupportCallSeverityTypes() {
        self.setError("");
        const types = yield fetcher()
          .post()
          .from.support_calls.severity_types();
        if (types.status === 200 && types.data) {
          self.setSupportCallSeverityTypes(types.data.value || []);
        } else {
          const errorText = "error:error_get_support_call_severity_types_req";
          self.setError(getErrorMessage(types, errorText));
        }
      }
    );

    function setError(error) {
      self.error = error;
    }

    function setSupportCalls(calls) {
      self.supportCalls = calls;
    }

    function setSupportCallTypes(types) {
      self.supportCallTypes = types;
    }

    function setSupportCallSeverityTypes(types) {
      self.supportCallSeverityTypes = types;
    }

    function setSupportCallStatuses(statuses) {
      self.supportCallStatuses = statuses;
    }
    function setUserCustomers(userCustomers) {
      self.userCustomers = userCustomers;
    }

    function setSelectedSupportCall(call) {
      self.selectedSupportCall = call;
    }

    return {
      getSupportCallsActive,
      getSupportCallStatuses,
      getSupportCallsHistory,
      getSupportCall,
      addNewComment,
      setError,
      setSelectedSupportCall,
      setSupportCalls,
      updateCommentExt,
      addNewSupportCall,
      deleteAttachment,
      addAttachment,
      setUserCustomers,
      getUserCustomers,
      getSupportCallTypes,
      setSupportCallTypes,
      getSupportCallSeverityTypes,
      setSupportCallSeverityTypes,
      setSupportCallStatuses,
      updateSupportCall,
    };
  })
  .views((self) => ({
    get isError() {
      return !!self.error;
    },
  }));

const supportCallsStore = SupportCallsStore.create({
  error: "",
  supportCalls: [],
  selectedSupportCall: undefined,
  userCustomers: [],
  supportCallTypes: [],
  supportCallSeverityTypes: [],
});

export default supportCallsStore;
